import { AnalyticsPathEnum } from '@setplex/tria-api'

export interface IParamsPageOpenEvent {
  entityId?: string
  contentTitle?: string
  publisherId?: number | string
  contentType?: string
  path?: AnalyticsPathEnum
}

export enum ProgramStatus {
  Past = 'past',
  Live = 'live',
  CatchUp = 'catchup',
  Future = 'future',
}

/** `sign_up` event_parameter1 — how the account was created (OVP-3049). */
export enum SignUpMethod {
  EmailPassword = 'email_password',
  Google = 'google',
  Apple = 'apple',
  Facebook = 'facebook',
}

/**
 * `sign_up` event_parameter2 — the surface the sign-up flow was started from.
 *
 * `LiveMyList` is the My List tab on the Live TV board (`GuestMyList` under the
 * category tabs). `MyList` is the nav-menu My List page.
 */
export enum SignUpEntryPoint {
  Header = 'header',
  MyList = 'my_list',
  LiveMyList = 'live_my_list',
}
